import { ActionButton, Checkbox, CommandButton, DetailsHeader, DetailsList, DetailsListLayoutMode, DetailsRow, ICheckboxStyles, IColumn, Icon, IDetailsColumnProps, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IDetailsRowBaseProps, IDetailsRowProps, IRenderFunction, Link, ProgressIndicator, Selection, SelectionMode, ShimmeredDetailsList, Stack, Toggle, TooltipHost, useTheme } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { EventPriceTypeEnum } from '../../../../../Models/Event/EventPriceTypeEnum';
import { IAttendeeRegistrationListItem, IAttendeeRegistrationListItemSelected } from '../../../../../Models/Event/IAttendeeRegistrationListItem';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';
import { PageTitle } from '../../../../PageTitle';
import { EmailAddressExportPanel } from '../../../Users/EmailAddressExportPanel/EmailAddressExportPanel';
import { AttendeeRegistrationGridList } from './AttendeeRegistrationGridList';

interface IAttendeeRegistrationListViewProps {
    items: IAttendeeRegistrationListItemSelected[];
    statusMessage?: IStatusMessage;
    isLoading: boolean;
    openDetail: (item: IAttendeeRegistrationListItemSelected) => void;
    invoiceSelection: (registrationId: number, fieldName: string, value: boolean) => void;
    invoiceAllSelection: (selectFa: keyof IAttendeeRegistrationListItemSelected, fieldName: string, value: boolean) => void
    onlyActiveFilter: boolean;
    setOnlyActiveFilter: (value: boolean) => void;
    addNewRegistration: () => void;
    createInvoices: () => void;
    profile: IUserProfile;
    exportToCsv: () => void;
}



export const AttendeeRegistrationListView: React.FunctionComponent<IAttendeeRegistrationListViewProps> = (props) => {
    const [disableCreateInvoiceButton, setDisableCreateInvoiceButton] = React.useState(true)  
    const [priceMode, setPriceMod] = React.useState();
    const [selectedItems, setSelectedItems] = React.useState<IAttendeeRegistrationListItemSelected[]>([]);


    //const itemInvoiceSelectedRef = React.useRef(itemInvoiceSelected);
    //const setItemInvoiceSelected = (value: IAttendeeRegistrationListItemSelected[]) => {
    //    itemInvoiceSelectedRef.current = value;
    //    _setItemInvoiceSelected(value);
    //}

    React.useEffect(() => {
        setDisableCreateInvoiceButton(props.items.filter(x => x.priceFirstSemesterInvoiceSelected || x.priceSecondSemesterInvoiceSelected || x.priceInvoiceSelected).length=== 0);
    }, [props.items])
    

    const theme = useTheme();

    const onlyActiveFilterChanged = (event?: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        props.setOnlyActiveFilter(checked ? checked : false);
    }

    return (
        <Stack styles={{ root: { paddingTop: 40 } }}>
            <Stack>
                <Toggle checked={props.onlyActiveFilter} onChange={onlyActiveFilterChanged} defaultChecked label="Pouze aktivní přihlášky" onText="Ano" offText="Ne" inlineLabel />
                <Stack horizontal verticalAlign="end">
                    {props.profile.isAdmin?<ActionButton onClick={props.addNewRegistration} iconProps={{ iconName: "Add" }} text="Přidej registraci" /> : null}
                    {props.profile.isAccountant && props.profile.isAdmin ? <ActionButton onClick={props.createInvoices} disabled={disableCreateInvoiceButton} iconProps={{ iconName: "NewFolder" }} text="Vytvoř faktury" /> : null}
                    <EmailAddressExportPanel emails={selectedItems.map(x => { return { email: x.email, firstname: x.firstName, lastname: x.lastName } })} />
                    <ActionButton onClick={props.exportToCsv} iconProps={{ iconName: "Save" }}  text="Uložit" />
                </Stack>                
            </Stack>
            <AttendeeRegistrationGridList
                items={props.items}
                isLoading={props.isLoading}
                openDetail={props.openDetail}
                setSelected={setSelectedItems}
                invoiceAllSelection={props.invoiceAllSelection}
                invoiceSelection={props.invoiceSelection}
                selectionMode={SelectionMode.multiple}
                profile={props.profile}
            />
        </Stack>
    )
}
